import {pushNotification} from '@malt/joy-v2/src/js/notification';

Hop.defineModule('postLink', (root, {url, onErrorMessage, onSuccessUrl, reload = true, verb = 'post'}) => {
    root.addEventListener('click', (e) => {
        e.preventDefault();

        fetch(url, {
            method: verb,
            credentials: 'include',
            headers: new Headers({
                'Content-Type': 'text/plain',
            }),
        }).then((data) => {
            if (data.status !== 200 && data.status !== 201 && data.status !== 204) {
                pushNotification(onErrorMessage, {level: 'error'});
                return;
            }

            if (onSuccessUrl) {
                window.location = onSuccessUrl;
            } else if (reload) {
                window.location.reload();
            }
        });
    });
});
